import type { UsageLineItem, CommitmentLineItem } from '@weft/types';
import { isNotEmptyArray } from '@weft/utils';
import React from 'react';

import { InvoiceConsumptionItemsCharges } from '../InvoiceConsumptionItemsCharges';
import { InvoicePerUnitUsageCharges } from './invoice-usage-based-charges-components/InvoicePerUnitUsageCharges';
import { InvoiceTiersUsageCharges } from './invoice-usage-based-charges-components/InvoiceTiersUsageCharges';

type InvoiceUsageBasedChargesProps = {
  usageLineItems: UsageLineItem[];
  tiersUsageLineItems: UsageLineItem[];
  perUnitUsageLineItems: UsageLineItem[];
  commitmentLineItems: CommitmentLineItem[];
};

export const InvoiceUsageBasedCharges: React.FC<InvoiceUsageBasedChargesProps> = ({
  tiersUsageLineItems,
  perUnitUsageLineItems,
  commitmentLineItems,
}) => {
  return (
    <div className="mt-10">
      <div className="text-title mb-4 text-base">Usage Fees</div>
      <div className="space-y-5">
        {isNotEmptyArray(tiersUsageLineItems) && <InvoiceTiersUsageCharges lineItems={tiersUsageLineItems}/>}
        {isNotEmptyArray(perUnitUsageLineItems) && <InvoicePerUnitUsageCharges lineItems={perUnitUsageLineItems}/>}
        {isNotEmptyArray(commitmentLineItems) && <InvoiceConsumptionItemsCharges lineItems={commitmentLineItems}/>}
      </div>
    </div>
  );
};